import { render } from "./Display.vue?vue&type=template&id=2dc2991c&scoped=true"
import script from "./Display.vue?vue&type=script&lang=js"
export * from "./Display.vue?vue&type=script&lang=js"

import "./Display.vue?vue&type=style&index=0&id=2dc2991c&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc2991c"]])

export default __exports__